export default __webpack_public_path__ + "static/media/connectTuitionLogo.a053f067.png";